'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _asyncGeneratorDelegate = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('./utils'),
    filter = _require.filter,
    sortAll = _require.sortAll,
    take = _require.take,
    map = _require.map;

var drain = require('it-drain');

var InterfaceDatastoreAdapter = /*#__PURE__*/function () {
  function InterfaceDatastoreAdapter() {
    _classCallCheck(this, InterfaceDatastoreAdapter);
  }

  _createClass(InterfaceDatastoreAdapter, [{
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "put",

    /**
     * Store the passed value under the passed key
     *
     * @param {Key} key
     * @param {Buffer} val
     * @param {Object} options
     * @returns {Promise<void>}
     */
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key, val) {
        var options,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function put(_x, _x2) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "putMany",

    /**
     * Store the given key/value pairs
     *
     * @param {AsyncIterator<{ key: Key, value: Buffer }>} source
     * @param {Object} options
     * @returns {AsyncIterator<{ key: Key, value: Buffer }>}
     */
    value: function putMany(source) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _value4, key, value;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context4.prev = 2;
                _iterator = _asyncIterator(source);

              case 4:
                _context4.next = 6;
                return _awaitAsyncGenerator(_iterator.next());

              case 6:
                _step = _context4.sent;
                _iteratorNormalCompletion = _step.done;
                _context4.next = 10;
                return _awaitAsyncGenerator(_step.value);

              case 10:
                _value = _context4.sent;

                if (_iteratorNormalCompletion) {
                  _context4.next = 20;
                  break;
                }

                _value4 = _value, key = _value4.key, value = _value4.value;
                _context4.next = 15;
                return _awaitAsyncGenerator(_this.put(key, value, options));

              case 15:
                _context4.next = 17;
                return {
                  key: key,
                  value: value
                };

              case 17:
                _iteratorNormalCompletion = true;
                _context4.next = 4;
                break;

              case 20:
                _context4.next = 26;
                break;

              case 22:
                _context4.prev = 22;
                _context4.t0 = _context4["catch"](2);
                _didIteratorError = true;
                _iteratorError = _context4.t0;

              case 26:
                _context4.prev = 26;
                _context4.prev = 27;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context4.next = 31;
                  break;
                }

                _context4.next = 31;
                return _awaitAsyncGenerator(_iterator.return());

              case 31:
                _context4.prev = 31;

                if (!_didIteratorError) {
                  _context4.next = 34;
                  break;
                }

                throw _iteratorError;

              case 34:
                return _context4.finish(31);

              case 35:
                return _context4.finish(26);

              case 36:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 22, 26, 36], [27,, 31, 35]]);
      }))();
    }
    /**
     * Retrieve the value for the passed key
     *
     * @param {Key} key
     * @param {Object} options
     * @returns {Promise<Buffer>}
     */

  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(key) {
        var options,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function get(_x3) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "getMany",

    /**
     * Retrieve values for the passed keys
     *
     * @param {AsyncIterator<Key>} source
     * @param {Object} options
     * @returns {AsyncIterator<Buffer>}
     */
    value: function getMany(source) {
      var _this2 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, key;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _context6.prev = 2;
                _iterator2 = _asyncIterator(source);

              case 4:
                _context6.next = 6;
                return _awaitAsyncGenerator(_iterator2.next());

              case 6:
                _step2 = _context6.sent;
                _iteratorNormalCompletion2 = _step2.done;
                _context6.next = 10;
                return _awaitAsyncGenerator(_step2.value);

              case 10:
                _value2 = _context6.sent;

                if (_iteratorNormalCompletion2) {
                  _context6.next = 18;
                  break;
                }

                key = _value2;
                _context6.next = 15;
                return _this2.get(key, options);

              case 15:
                _iteratorNormalCompletion2 = true;
                _context6.next = 4;
                break;

              case 18:
                _context6.next = 24;
                break;

              case 20:
                _context6.prev = 20;
                _context6.t0 = _context6["catch"](2);
                _didIteratorError2 = true;
                _iteratorError2 = _context6.t0;

              case 24:
                _context6.prev = 24;
                _context6.prev = 25;

                if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                  _context6.next = 29;
                  break;
                }

                _context6.next = 29;
                return _awaitAsyncGenerator(_iterator2.return());

              case 29:
                _context6.prev = 29;

                if (!_didIteratorError2) {
                  _context6.next = 32;
                  break;
                }

                throw _iteratorError2;

              case 32:
                return _context6.finish(29);

              case 33:
                return _context6.finish(24);

              case 34:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[2, 20, 24, 34], [25,, 29, 33]]);
      }))();
    }
    /**
     * Check for the existence of a value for the passed key
     *
     * @param {Key} key
     * @returns {Promise<bool>}
     */

  }, {
    key: "has",
    value: function () {
      var _has = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(key) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function has(_x4) {
        return _has.apply(this, arguments);
      }

      return has;
    }()
  }, {
    key: "delete",

    /**
     * Remove the record for the passed key
     *
     * @param {Key} key
     * @param {Object} options
     * @returns {Promise<void>}
     */
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(key) {
        var options,
            _args8 = arguments;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                options = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function _delete(_x5) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "deleteMany",

    /**
     * Remove values for the passed keys
     *
     * @param {AsyncIterator<Key>} source
     * @param {Object} options
     * @returns {AsyncIterator<Key>}
     */
    value: function deleteMany(source) {
      var _this3 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _value3, key;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _context9.prev = 2;
                _iterator3 = _asyncIterator(source);

              case 4:
                _context9.next = 6;
                return _awaitAsyncGenerator(_iterator3.next());

              case 6:
                _step3 = _context9.sent;
                _iteratorNormalCompletion3 = _step3.done;
                _context9.next = 10;
                return _awaitAsyncGenerator(_step3.value);

              case 10:
                _value3 = _context9.sent;

                if (_iteratorNormalCompletion3) {
                  _context9.next = 20;
                  break;
                }

                key = _value3;
                _context9.next = 15;
                return _awaitAsyncGenerator(_this3.delete(key, options));

              case 15:
                _context9.next = 17;
                return key;

              case 17:
                _iteratorNormalCompletion3 = true;
                _context9.next = 4;
                break;

              case 20:
                _context9.next = 26;
                break;

              case 22:
                _context9.prev = 22;
                _context9.t0 = _context9["catch"](2);
                _didIteratorError3 = true;
                _iteratorError3 = _context9.t0;

              case 26:
                _context9.prev = 26;
                _context9.prev = 27;

                if (!(!_iteratorNormalCompletion3 && _iterator3.return != null)) {
                  _context9.next = 31;
                  break;
                }

                _context9.next = 31;
                return _awaitAsyncGenerator(_iterator3.return());

              case 31:
                _context9.prev = 31;

                if (!_didIteratorError3) {
                  _context9.next = 34;
                  break;
                }

                throw _iteratorError3;

              case 34:
                return _context9.finish(31);

              case 35:
                return _context9.finish(26);

              case 36:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[2, 22, 26, 36], [27,, 31, 35]]);
      }))();
    }
    /**
     * Create a new batch object.
     *
     * @returns {Object}
     */

  }, {
    key: "batch",
    value: function batch() {
      var _this5 = this;

      var puts = [];
      var dels = [];
      return {
        put: function put(key, value) {
          puts.push({
            key: key,
            value: value
          });
        },
        delete: function _delete(key) {
          dels.push(key);
        },
        commit: function () {
          var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(options) {
            return _regeneratorRuntime.wrap(function _callee10$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    _context10.next = 2;
                    return drain(_this5.putMany(puts, options));

                  case 2:
                    puts = [];
                    _context10.next = 5;
                    return drain(_this5.deleteMany(dels, options));

                  case 5:
                    dels = [];

                  case 6:
                  case "end":
                    return _context10.stop();
                }
              }
            }, _callee10);
          }));

          function commit(_x6) {
            return _commit.apply(this, arguments);
          }

          return commit;
        }()
      };
    }
    /**
     * Yield all datastore values
     *
     * @param {Object} q
     * @param {Object} options
     * @returns {AsyncIterable<{ key: Key, value: Buffer }>}
     */

  }, {
    key: "_all",
    value: function _all(q, options) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    } // eslint-disable-line require-await

    /**
     * Query the store.
     *
     * @param {Object} q
     * @param {Object} options
     * @returns {AsyncIterable<Buffer>}
     */

  }, {
    key: "query",
    value: function query(q, options) {
      var _this4 = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var it, i;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                // eslint-disable-line require-await
                it = _this4._all(q, options);

                if (q.prefix != null) {
                  it = filter(it, function (e) {
                    return e.key.toString().startsWith(q.prefix);
                  });
                }

                if (Array.isArray(q.filters)) {
                  it = q.filters.reduce(function (it, f) {
                    return filter(it, f);
                  }, it);
                }

                if (Array.isArray(q.orders)) {
                  it = q.orders.reduce(function (it, f) {
                    return sortAll(it, f);
                  }, it);
                }

                if (q.offset != null) {
                  i = 0;
                  it = filter(it, function () {
                    return i++ >= q.offset;
                  });
                }

                if (q.limit != null) {
                  it = take(it, q.limit);
                }

                if (q.keysOnly === true) {
                  it = map(it, function (e) {
                    return {
                      key: e.key
                    };
                  });
                }

                return _context12.delegateYield(_asyncGeneratorDelegate(_asyncIterator(it), _awaitAsyncGenerator), "t0", 8);

              case 8:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    }
  }]);

  return InterfaceDatastoreAdapter;
}();

module.exports = InterfaceDatastoreAdapter;